import React, { useEffect } from 'react';
import { GoogleTagManager } from '../../helpers';
import {
  CDA,
  Chat,
  OtherChannels,
  Roaming,
  RequestClaims,
  HelpCard,
  FAQSection,
} from '../../components/Help';
import PageTemplate from '../../components/UI/PageTemplate/pageTemplate';
import { NavChevron } from '../../components/UI/PageTemplate';

const Ayuda = () => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda',
      pagename: 'AYUDA_ONLOAD',
    });
  }, []);

  return (
    <PageTemplate seo="Ayuda">
      <NavChevron title="Ayuda" level="first" />
      <CDA />
      <Chat
        title="Chat de ayuda"
        subtitle="Resolvemos tus dudas al instante"
        showButton={false}
        from="Ayuda"
      />
      <HelpCard />
      <Roaming />
      <RequestClaims />
      <OtherChannels />
      <FAQSection section="Ayuda" />
    </PageTemplate>
  );
};

export default Ayuda;
